export default __webpack_public_path__ + "media/images/features/yado/bg-f457d9eb733771ea4bf38af299641672.jpg";